import React from 'react'

import {
  Grid,
  Input,
  Picker,
  SelectForm,
} from 'components'
import { usePersistForm } from 'hooks'
import { useFormContext } from 'react-hook-form'
import { IGetAllPaginatedParams } from 'services/NGT/Log'
import { SPACING } from 'utils'

const Form: React.FC = () => {
  const {
    control,
    setValue,
    formState: { errors },
    watch
  } = useFormContext<IGetAllPaginatedParams>()

  usePersistForm('logs-list-ngt-form', {
    setValue,
    watch
  })

  return (
    <>
      <Grid
        gridCols="1fr 1fr 1fr 1fr 1fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`0 0 ${SPACING.spacing20} 0`}
      >
        <Input
          control={control}
          errors={errors}
          label="Pesquisar"
          formValue="txPesquisa"
          placeholder="Digite a pesquisa"
        />
        <Picker
          control={control}
          errors={errors}
          label="Data Início"
          formValue="dtInicio"
          maxDate={watch('dtFim')}
        />
        <Picker
          control={control}
          errors={errors}
          label="Data Fim"
          minDate={watch('dtInicio')}
          formValue="dtFim"
          />
        <SelectForm
          control={control}
          errors={errors}
          label="API"
          placeholder="Selecione"
          formValue="txNmApi"
          listOptions={[
            {
              label: 'CDU',
              value: 'CDU_API',
            },
            {
              label: 'READ',
              value: 'READ_API',
            },
            {
              label: 'GATEWAY',
              value: 'GATEWAY_API',
            },
            {
              label: 'GST',
              value: 'GST_API',
            },
          ]}
        />
        <SelectForm
          control={control}
          errors={errors}
          label="Nível Log"
          placeholder="Selecione"
          formValue="txNivelLog"
          listOptions={[
            {
              label: 'Information',
              value: 'Information',
            },
            {
              label: 'Error',
              value: 'Error',
            },
          ]}
        />
      </Grid>
    </>
  )
}

export default Form
